import { loading } from "../assets";

const Generating = ({ className }) => {
  return (
    <div
      className={`
        flex flex-col sm:flex-row
        items-center justify-center
        space-y-2 sm:space-y-0 sm:space-x-20  /* Increased horizontal gap */
        px-6 py-3
        bg-n-8/80
        rounded-[1.7rem]
        text-base
        leading-relaxed
        text-center
        ${className || ""}
      `}
    >
      {/* Icon + Launch Text */}
      <div className="flex items-center justify-center">
        <img
          className="w-5 h-5 mr-2"
          src={loading}
          alt="Loading"
        />
        <span className="font-semibold whitespace-nowrap">
          Launching Q2 2025
        </span>
      </div>

      {/* Main Text */}
      <p className="max-w-sm">
        The future of business intelligence is here.
        <br className="hidden sm:inline" /> <br/>
        Are you ready to thrive?
      </p>
    </div>
  );
};

export default Generating;

